import type { CatalogRow } from '@/types/toolkit.types';

/**
 * Keeps the cards that contain every word of the search text, in any order and ignoring case, in their
 * name, their description or their row's title. Rows with no card left are dropped, so the catalog never
 * shows an empty row.
 */
export function filterCatalog(rows: CatalogRow[], searchText: string): CatalogRow[] {
  const words = searchText.trim().toLowerCase().split(/\s+/).filter(Boolean);

  if (words.length === 0) {
    return rows;
  }

  const matches = (rowTitle: string, card: { name: string; description: string }) => {
    const text = `${card.name} ${card.description} ${rowTitle}`.toLowerCase();
    return words.every((word) => text.includes(word));
  };

  return rows
    .map((row): CatalogRow =>
      row.kind === 'models'
        ? { ...row, cards: row.cards.filter((card) => matches(row.title, card)) }
        : { ...row, cards: row.cards.filter((card) => matches(row.title, card)) },
    )
    .filter((row) => row.cards.length > 0);
}
